import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { Alert, AlertDescription } from './ui/alert';

const ErrorMessage = ({ error, onRetry = null, message = null }) => {
  const errorMessage = message || error?.response?.data?.detail || error?.message || 'Ha ocurrido un error inesperado';

  return (
    <div className="py-8">
      <Alert className="border-red-200 bg-red-50">
        <AlertCircle className="h-4 w-4 text-red-600" />
        <AlertDescription className="text-red-800 font-medium">
          {errorMessage}
        </AlertDescription>
      </Alert>
      
      {onRetry && (
        <div className="flex justify-center mt-4">
          <Button 
            onClick={onRetry} 
            variant="outline" 
            size="sm"
            className="border-red-300 text-red-700 hover:bg-red-50"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Reintentar
          </Button>
        </div>
      )}
    </div>
  );
};

export default ErrorMessage;